import { Account } from '@hcs/types';
import { ACCOUNT_URL } from '@hcs/urls';

import { AxiosClient, queryClient } from '../clients';
import { ACCOUNT_QUERY_KEY } from '../constants';

import { authHeaderFnAccountApi } from './authHeaders.utils';

export const getAccessTokenFromCache = () => {
  const account = queryClient.getQueryData<Account>([ACCOUNT_QUERY_KEY]);
  return account?.token?.access;
};

const removeAllQueriesExceptAccount = () => {
  const queryCache = queryClient.getQueryCache();
  queryCache.getAll().forEach(({ queryKey }) => {
    if (queryKey.length === 1 && queryKey[0] === ACCOUNT_QUERY_KEY) {
      // leave the account query
    } else {
      queryClient.removeQueries({ queryKey });
    }
  });
};

export const resetAccountQuery = () => {
  // we need to reset the account query (as opposed to removing) so a refetch is triggered (and thus a re-render to it's subscribers)
  queryClient.resetQueries({ queryKey: [ACCOUNT_QUERY_KEY] });
  removeAllQueriesExceptAccount();
};

export const fetchAccount = async (account?: Account) => {
  // some endpoints already get account back - like login, so we don't need to fetch it again
  if (!account) {
    // refresh needs the existing access token to do some login-as checks
    const existingAccessToken = getAccessTokenFromCache();
    const accountResponse = await AxiosClient.post<Account>(
      `${ACCOUNT_URL}/auth/refresh`,
      undefined,
      {
        headers: authHeaderFnAccountApi(existingAccessToken || null),
        withCredentials: true,
      },
    );
    account = accountResponse.data;
  }

  return account;
};
